(() => {
  'use strict';

  const header = document.querySelector('[data-site-header]');
  const setHeaderState = () => header?.classList.toggle('is-scrolled', window.scrollY > 12);
  setHeaderState();
  window.addEventListener('scroll', setHeaderState, { passive: true });

  document.querySelectorAll('.mobile-nav a').forEach((link) => {
    link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
  });

  const wizard = document.querySelector('[data-lead-wizard]');
  const form = document.getElementById('MedunoriaLeadForm');

  if (wizard && form && !form.querySelector('[data-form-success]')) {
    const steps = Array.from(form.querySelectorAll('[data-step]'));
    const nextButton = form.querySelector('[data-next]');
    const backButton = form.querySelector('[data-back]');
    const submitButton = form.querySelector('[data-submit]');
    const progress = wizard.querySelector('[data-progress]');
    const stepCount = wizard.querySelector('[data-step-count]');
    const summary = form.querySelector('#LeadSummary');
    let currentStep = 0;

    const field = (selector) => form.querySelector(selector);
    const selectedValue = (name) => form.querySelector(`[name="${name}"]:checked`)?.value || '';

    const setError = (step, message = '') => {
      const target = steps[step]?.querySelector('[data-error]');
      if (target) target.textContent = message;
    };

    const focusStep = () => {
      const legend = steps[currentStep]?.querySelector('legend');
      if (legend) {
        legend.tabIndex = -1;
        legend.focus({ preventScroll: true });
      }
      if (window.innerWidth < 880) {
        wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const renderStep = (focus = false) => {
      steps.forEach((step, index) => {
        const active = index === currentStep;
        step.classList.toggle('is-active', active);
        step.setAttribute('aria-hidden', String(!active));
      });
      if (stepCount) stepCount.textContent = `0${currentStep + 1} / 04`;
      if (progress) progress.style.width = `${(currentStep + 1) * 25}%`;
      if (backButton) backButton.hidden = currentStep === 0;
      if (nextButton) nextButton.hidden = currentStep === steps.length - 1;
      if (submitButton) submitButton.hidden = currentStep !== steps.length - 1;
      if (focus) focusStep();
    };

    const validateStep = (step) => {
      setError(step);

      if (step === 0) {
        const financing = selectedValue('contact[Kostenübernahme]');
        if (!financing) {
          setError(step, 'Bitte wählen Sie eine Art der Kostenübernahme.');
          return false;
        }
        if (financing === 'Nur Kassenleistung') {
          setError(step, 'MEDUNORIA vermittelt keine reinen Kassenleistungen ohne private Selbstzahlungsbereitschaft. In Deutschland können Sie sich an Ihre Krankenkasse oder 116117 wenden.');
          return false;
        }
      }

      if (step === 1) {
        if (!field('#LeadSpecialty')?.value || !field('#LeadAppointment')?.value) {
          setError(step, 'Bitte wählen Sie eine Fachrichtung und die gewünschte Terminart.');
          return false;
        }
      }

      if (step === 2) {
        const location = field('#LeadLocation')?.value.trim() || '';
        if (location.length < 2) {
          setError(step, 'Bitte geben Sie einen Ort oder eine Postleitzahl an.');
          return false;
        }
      }

      if (step === 3) {
        const name = field('#LeadName')?.value.trim() || '';
        const email = field('#LeadEmail')?.value.trim() || '';
        const emailOkay = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        const checks = Array.from(steps[3].querySelectorAll('input[type="checkbox"][required]'));

        if (name.length < 2) {
          setError(step, 'Bitte geben Sie Ihren Vor- und Nachnamen an.');
          return false;
        }
        if (!emailOkay) {
          setError(step, 'Bitte geben Sie eine gültige E-Mail-Adresse an.');
          return false;
        }
        if (checks.some((checkbox) => !checkbox.checked)) {
          setError(step, 'Bitte bestätigen Sie Volljährigkeit, Kostenhinweis und Datenschutzeinwilligung.');
          return false;
        }
      }
      return true;
    };

    const firstInvalidStep = () => {
      for (let index = 0; index < steps.length; index += 1) {
        if (!validateStep(index)) return index;
      }
      return -1;
    };

    const createSummary = () => {
      const value = (selector) => field(selector)?.value.trim() || 'Nicht angegeben';
      return [
        'MEDUNORIA VERMITTLUNGSANFRAGE',
        '',
        `Name: ${value('#LeadName')}`,
        `E-Mail: ${value('#LeadEmail')}`,
        `Kostenübernahme: ${selectedValue('contact[Kostenübernahme]')}`,
        `Fachrichtung: ${value('#LeadSpecialty')}`,
        `Terminwunsch: ${value('#LeadAppointment')}`,
        `Wunschland: ${value('#LeadCountry')}`,
        `Region: ${value('#LeadLocation')}`,
        `Suchradius: ${value('#LeadRadius')}`,
        `Zeitraum: ${value('#LeadTiming')}`,
        '',
        'Ausdrückliche Datenschutzeinwilligung: erteilt',
        'Volljährigkeit/Sorgeberechtigung: bestätigt',
        'Kostenhinweis: bestätigt',
        '',
        'Es wurden keine Diagnosen, Symptome, Befunde oder Dokumente abgefragt.'
      ].join('\n');
    };

    nextButton?.addEventListener('click', () => {
      if (!validateStep(currentStep)) return;
      currentStep = Math.min(currentStep + 1, steps.length - 1);
      renderStep(true);
    });

    backButton?.addEventListener('click', () => {
      currentStep = Math.max(currentStep - 1, 0);
      renderStep(true);
    });

    form.addEventListener('submit', (event) => {
      const invalidStep = firstInvalidStep();
      if (invalidStep !== -1) {
        event.preventDefault();
        currentStep = invalidStep;
        renderStep(true);
        return;
      }
      if (summary) summary.value = createSummary();
      submitButton?.setAttribute('aria-busy', 'true');
      if (submitButton) submitButton.textContent = 'Anfrage wird gesendet …';
    });

    renderStep();
  }

  const partnerWizard = document.querySelector('[data-partner-wizard]');
  const partnerForm = document.getElementById('MedunoriaPartnerForm');

  if (partnerWizard && partnerForm && !partnerForm.querySelector('[data-partner-success]')) {
    const steps = Array.from(partnerForm.querySelectorAll('[data-partner-step]'));
    const nextButton = partnerForm.querySelector('[data-partner-next]');
    const backButton = partnerForm.querySelector('[data-partner-back]');
    let submitButton = partnerForm.querySelector('[data-partner-submit]');
    const submitSlot = partnerForm.querySelector('[data-partner-submit-slot]');
    const submitTemplate = partnerForm.querySelector('[data-partner-submit-template]');
    const submitHint = partnerForm.querySelector('[data-partner-submit-hint]');
    const progress = partnerWizard.querySelector('[data-partner-progress]');
    const stepCount = partnerWizard.querySelector('[data-partner-step-count]');
    const summary = partnerForm.querySelector('#PartnerSummary');
    let currentStep = 0;

    const field = (selector) => partnerForm.querySelector(selector);
    const selectedValue = (name) => partnerForm.querySelector(`[name="${name}"]:checked`)?.value || '';
    const checkedLabels = (selector) => Array.from(partnerForm.querySelectorAll(`${selector} input:checked`))
      .map((input) => input.closest('label')?.querySelector('strong')?.textContent.trim() || input.value)
      .join(', ');

    const setError = (step, message = '') => {
      const target = steps[step]?.querySelector('[data-partner-error]');
      if (target) target.textContent = message;
    };

    const focusStep = () => {
      const legend = steps[currentStep]?.querySelector('legend');
      if (legend) {
        legend.tabIndex = -1;
        legend.focus({ preventScroll: true });
      }
      partnerWizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const syncSubmitButton = (ready) => {
      if (ready && !submitButton && submitSlot && submitTemplate) {
        submitSlot.appendChild(submitTemplate.content.cloneNode(true));
        submitButton = submitSlot.querySelector('[data-partner-submit]');
      }
      if (!ready && submitButton) {
        submitButton.remove();
        submitButton = null;
      }
      if (submitSlot) submitSlot.hidden = !ready;
      if (submitButton) {
        submitButton.disabled = !ready;
        submitButton.setAttribute('aria-hidden', String(!ready));
      }
    };

    const renderStep = (focus = false) => {
      steps.forEach((step, index) => {
        const active = index === currentStep;
        step.classList.toggle('is-active', active);
        step.setAttribute('aria-hidden', String(!active));
      });
      if (stepCount) stepCount.textContent = `0${currentStep + 1} / 04`;
      if (progress) progress.style.width = `${(currentStep + 1) * 25}%`;
      if (backButton) backButton.hidden = currentStep === 0;
      if (nextButton) nextButton.hidden = currentStep === steps.length - 1;
      const onFinalStep = currentStep === steps.length - 1;
      const readyToSubmit = onFinalStep && isPartnerFormReady();
      syncSubmitButton(readyToSubmit);
      if (submitHint) submitHint.hidden = !onFinalStep || readyToSubmit;
      if (focus) focusStep();
    };

    const validEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    const allRequiredChecksMarked = (step) => Array.from(steps[step].querySelectorAll('input[type="checkbox"][required]'))
      .every((checkbox) => checkbox.checked);
    const isPartnerFormReady = () => {
      const allControlsValid = Array.from(partnerForm.elements)
        .filter((control) => control.willValidate)
        .every((control) => control.validity.valid);
      const requiredControlsFilled = Array.from(partnerForm.querySelectorAll('[required]'))
        .every((control) => {
          if (control.matches('input[type="checkbox"], input[type="radio"]')) return control.validity.valid;
          return control.value.trim().length > 0 && control.validity.valid;
        });
      const patientGroupReady = Boolean(partnerForm.querySelector('[data-partner-patients] input:checked'));
      const serviceGroupReady = Boolean(partnerForm.querySelector('[data-partner-services] input:checked'));
      const requiredChecksReady = Array.from(partnerForm.querySelectorAll('input[type="checkbox"][required]'))
        .every((checkbox) => checkbox.checked);
      return allControlsValid && requiredControlsFilled && requiredChecksReady && patientGroupReady && serviceGroupReady;
    };

    const validateStep = (step) => {
      setError(step);

      if (step === 0) {
        const practice = field('#PartnerPractice')?.value.trim() || '';
        const name = field('#PartnerName')?.value.trim() || '';
        const role = field('#PartnerRole')?.value.trim() || '';
        const email = field('#PartnerEmail')?.value.trim() || '';
        if (!selectedValue('contact[Partnerart]')) {
          setError(step, 'Bitte wählen Sie aus, wer sich bewirbt.');
          return false;
        }
        if (practice.length < 2 || name.length < 2 || role.length < 2) {
          setError(step, 'Bitte vervollständigen Sie Praxis, Ansprechperson und Funktion.');
          return false;
        }
        if (!validEmail(email)) {
          setError(step, 'Bitte geben Sie eine gültige geschäftliche E-Mail-Adresse an.');
          return false;
        }
      }

      if (step === 1) {
        const specialty = field('#PartnerSpecialty')?.value || '';
        const country = field('#PartnerCountry')?.value || '';
        const location = field('#PartnerLocation')?.value.trim() || '';
        if (!specialty || !country || location.length < 2) {
          setError(step, 'Bitte wählen Sie Hauptfachrichtung und Land und ergänzen Sie den Praxisstandort.');
          return false;
        }
        if (!allRequiredChecksMarked(step)) {
          setError(step, 'Bitte bestätigen Sie Berufserlaubnis, Qualifikationsnachweise und Haftpflicht.');
          return false;
        }
      }

      if (step === 2) {
        if (!partnerForm.querySelector('[data-partner-patients] input:checked')) {
          setError(step, 'Bitte wählen Sie mindestens eine passende Patientengruppe.');
          return false;
        }
        if (!partnerForm.querySelector('[data-partner-services] input:checked')) {
          setError(step, 'Bitte wählen Sie mindestens eine angebotene Leistungsform.');
          return false;
        }
        if (!field('#PartnerCapacity')?.value || !field('#PartnerResponse')?.value) {
          setError(step, 'Bitte ergänzen Sie Aufnahmekapazität und übliche Rückmeldefrist.');
          return false;
        }
      }

      if (step === 3 && !allRequiredChecksMarked(step)) {
        setError(step, 'Bitte bestätigen Sie alle Erklärungen zur Bewerbung und zum Datenschutz.');
        return false;
      }

      return true;
    };

    const firstInvalidStep = () => {
      for (let index = 0; index < steps.length; index += 1) {
        if (!validateStep(index)) return index;
      }
      return -1;
    };

    const createPartnerSummary = () => {
      const value = (selector) => field(selector)?.value.trim() || 'Nicht angegeben';
      return [
        'MEDUNORIA PARTNERBEWERBUNG',
        '',
        `Partnerart: ${selectedValue('contact[Partnerart]')}`,
        `Praxis / Einrichtung: ${value('#PartnerPractice')}`,
        `Ansprechperson: ${value('#PartnerName')}`,
        `Funktion: ${value('#PartnerRole')}`,
        `E-Mail: ${value('#PartnerEmail')}`,
        `Website: ${value('#PartnerWebsite')}`,
        '',
        `Hauptfachrichtung: ${value('#PartnerSpecialty')}`,
        `Weitere Fachrichtungen: ${value('#PartnerAdditionalSpecialties')}`,
        `Land: ${value('#PartnerCountry')}`,
        `Praxisstandort: ${value('#PartnerLocation')}`,
        `Patientengruppen: ${checkedLabels('[data-partner-patients]')}`,
        `Leistungsformen: ${checkedLabels('[data-partner-services]')}`,
        `Aufnahmekapazität: ${value('#PartnerCapacity')}`,
        `Rückmeldefrist: ${value('#PartnerResponse')}`,
        '',
        `Zusätzliche Angaben: ${value('#PartnerMessage')}`,
        '',
        'Approbation/Berufserlaubnis: bestätigt',
        'Qualifikationsnachweise: bestätigt',
        'Berufs-/Betriebshaftpflicht: bestätigt',
        'Vertretungsbefugnis und Richtigkeit: bestätigt',
        'Keine Patientendaten übermittelt: bestätigt',
        'Datenschutz zur Partnerbewerbung: akzeptiert',
        'Unverbindlichkeit und separate Vereinbarung: bestätigt'
      ].join('\n');
    };

    nextButton?.addEventListener('click', () => {
      if (!validateStep(currentStep)) return;
      currentStep = Math.min(currentStep + 1, steps.length - 1);
      renderStep(true);
    });

    backButton?.addEventListener('click', () => {
      currentStep = Math.max(currentStep - 1, 0);
      renderStep(true);
    });

    const refreshSubmitState = () => {
      if (currentStep === steps.length - 1) renderStep();
    };
    partnerForm.addEventListener('input', refreshSubmitState);
    partnerForm.addEventListener('change', refreshSubmitState);

    partnerForm.addEventListener('submit', (event) => {
      const invalidStep = firstInvalidStep();
      if (invalidStep !== -1) {
        event.preventDefault();
        currentStep = invalidStep;
        renderStep(true);
        return;
      }
      if (summary) summary.value = createPartnerSummary();
      submitButton?.setAttribute('aria-busy', 'true');
      if (submitButton) submitButton.textContent = 'Bewerbung wird gesendet …';
    });

    renderStep();
  }

  const specialtySelect = document.querySelector('[data-specialty-select]');
  const chooseSpecialty = (specialty = '') => {
    if (specialtySelect && specialty) specialtySelect.value = specialty;
    document.querySelector('#anfrage')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.setTimeout(() => {
      const activeChoice = document.querySelector('[data-step="0"] input');
      activeChoice?.focus({ preventScroll: true });
    }, 450);
  };

  document.querySelectorAll('[data-specialty]').forEach((button) => {
    button.addEventListener('click', () => chooseSpecialty(button.dataset.specialty));
  });
  document.querySelector('[data-all-specialties]')?.addEventListener('click', () => chooseSpecialty());

  const motionButton = document.querySelector('[data-motion-toggle]');
  let motionPaused = false;
  try { motionPaused = localStorage.getItem('medunoria-motion') === 'paused'; } catch (_) {}

  const renderMotion = () => {
    document.body.classList.toggle('motion-paused', motionPaused);
    if (!motionButton) return;
    motionButton.setAttribute('aria-pressed', String(motionPaused));
    motionButton.innerHTML = motionPaused
      ? 'Animation starten <span aria-hidden="true">▶</span>'
      : 'Animation pausieren <span aria-hidden="true">Ⅱ</span>';
  };
  renderMotion();
  motionButton?.addEventListener('click', () => {
    motionPaused = !motionPaused;
    try { localStorage.setItem('medunoria-motion', motionPaused ? 'paused' : 'running'); } catch (_) {}
    renderMotion();
  });

  const art = document.querySelector('[data-parallax-art]');
  const depthField = document.querySelector('[data-depth-field]');
  const brandOrbit = document.querySelector('[data-brand-orbit]');
  const partnerTilt = document.querySelector('[data-partner-tilt]');
  const partnerSculpture = document.querySelector('[data-partner-sculpture]');
  const brandLogos = Array.from(document.querySelectorAll('[data-brand-logo]'));
  const canAnimate = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ((art || depthField || brandOrbit || partnerTilt || partnerSculpture) && canAnimate) {
    window.addEventListener('pointermove', (event) => {
      if (motionPaused || event.pointerType === 'touch') return;
      const x = ((event.clientX / window.innerWidth) - .5) * 6;
      const y = ((event.clientY / window.innerHeight) - .5) * -4;
      art?.style.setProperty('--art-x', `${x.toFixed(2)}deg`);
      art?.style.setProperty('--art-y', `${y.toFixed(2)}deg`);
      depthField?.style.setProperty('--depth-x', `${(x * 4.2).toFixed(2)}px`);
      depthField?.style.setProperty('--depth-y', `${(y * -4.2).toFixed(2)}px`);
      brandOrbit?.style.setProperty('--brand-rx', `${(y * .8).toFixed(2)}deg`);
      brandOrbit?.style.setProperty('--brand-ry', `${(x * 1.2).toFixed(2)}deg`);
      brandOrbit?.style.setProperty('--brand-x', `${(x * 1.6).toFixed(2)}px`);
      brandOrbit?.style.setProperty('--brand-y', `${(y * -1.4).toFixed(2)}px`);
      partnerTilt?.style.setProperty('--partner-rx', `${(y * .65).toFixed(2)}deg`);
      partnerTilt?.style.setProperty('--partner-ry', `${(x * 1.05).toFixed(2)}deg`);
      partnerSculpture?.style.setProperty('--sculpture-rx', `${(y * .75).toFixed(2)}deg`);
      partnerSculpture?.style.setProperty('--sculpture-ry', `${(x * 1.15).toFixed(2)}deg`);
      partnerSculpture?.style.setProperty('--sculpture-x', `${(x * 1.15).toFixed(2)}px`);
      partnerSculpture?.style.setProperty('--sculpture-y', `${(y * -1.1).toFixed(2)}px`);
    }, { passive: true });

    window.addEventListener('pointerdown', (event) => {
      if (motionPaused || event.pointerType === 'touch') return;
      const aura = document.createElement('span');
      aura.className = 'click-aura';
      aura.style.left = `${event.clientX}px`;
      aura.style.top = `${event.clientY}px`;
      document.body.appendChild(aura);
      aura.addEventListener('animationend', () => aura.remove(), { once: true });
    }, { passive: true });
  }

  if (canAnimate) {
    brandLogos.forEach((brand) => {
      const stage = brand.querySelector('.brand__logo-stage');
      if (!stage) return;

      brand.addEventListener('pointermove', (event) => {
        if (motionPaused || event.pointerType === 'touch') return;
        const rect = brand.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) - .5;
        const y = ((event.clientY - rect.top) / rect.height) - .5;
        stage.style.setProperty('--logo-rx', `${(-y * 7).toFixed(2)}deg`);
        stage.style.setProperty('--logo-ry', `${(x * 10).toFixed(2)}deg`);
        stage.style.setProperty('--logo-z', '8px');
      }, { passive: true });

      brand.addEventListener('pointerleave', () => {
        stage.style.setProperty('--logo-rx', '0deg');
        stage.style.setProperty('--logo-ry', '0deg');
        stage.style.setProperty('--logo-z', '0px');
      }, { passive: true });
    });
  }

  const partnerSuccessRedirect = document.querySelector('[data-partner-success-redirect]');
  if (partnerSuccessRedirect?.dataset.partnerSuccessRedirect) {
    window.location.replace(partnerSuccessRedirect.dataset.partnerSuccessRedirect);
  }

  const partnerSuccessPage = document.querySelector('[data-partner-success-page]');
  if (partnerSuccessPage) {
    requestAnimationFrame(() => partnerSuccessPage.classList.add('is-celebrating'));
    partnerSuccessPage.focus({ preventScroll: true });
  }

  document.querySelector('[data-form-success]')?.focus({ preventScroll: true });
  document.querySelector('[data-partner-success]')?.focus({ preventScroll: true });
})();
